import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'

interface RtvDetailsParams {
  variant_sku?: string
  parent_sku?: string
}

const useGetRtvDetails = (params: RtvDetailsParams = {}) => {
  const Api = useApi()

  const initialFilters = {
    parent_sku: params.parent_sku || null,
    variant_sku: params.variant_sku || null,
    returns_type: 'rtv',  
  }

  const {filters, setSingleFilter} = useFilters(initialFilters)
  const url = params.variant_sku ? `/analytics/sold-products/zoho/returns/data` : `/analytics/sold-products/zoho/returns/parent/data`
  const {data: response, isFetching, refetch} = Api.useGetQuery(
    url,
    {
      queryId: `rtv-details-${params.variant_sku}`,
      filters: filters,
      isToast: false,
    },
    {
      enabled: !!params.variant_sku || !!params.parent_sku, // Only fetch when variant_sku is provided
    }
  )

  const fetchRtvDetails = (variantSku: string, parentSku: string) => {
    setSingleFilter('variant_sku', variantSku)
    setSingleFilter('parent_sku', parentSku)
    refetch()
  }

  return {
    rtvDetails: response?.data,
    isLoading: isFetching,
    filters,
    fetchRtvDetails,
    refetch,
  }
}

export default useGetRtvDetails
